import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel-hot-fix";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { faAlignRight } from "@fortawesome/free-solid-svg-icons";
import { text } from "@fortawesome/fontawesome-svg-core";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class History extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      submittedDateFrom: "",
      submittedDateTo: "",
      sAwbNo: "",
      sInvoiceNo: "",
      export: false,
      fileurl:''
    };
  }

  componentDidMount = () => {};

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "Activity Date",
          accessor: "creation_date",
          width: 150,
          filterable: true,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Type",
          accessor: "process",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Invoice No.",
          accessor: "trx_number",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "TTF No.",
          accessor: "ttf_no",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "No Faktur Pajak",
          accessor: "no_faktur_pajak",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },

        {
          Header: "No PO",
          accessor: "no_po",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },

        {
          Header: "Amount",
          accessor: "original_amount",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : ""}
              </span>
            </div>
          ),
        },

        {
          Header: "Sender",
          accessor: "source",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Recepient",
          accessor: "org_des_name",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Destination",
          accessor: "destination",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Document No",
          accessor: "doc_no",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Doc Date",
          accessor: "doc_date",
          filterable: true,
          //   width: 150,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          // ,filterable: true
        },
        {
          Header: "AWB No.",
          accessor: "awb_no",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Awb Date",
          accessor: "awb_date",
          filterable: true,
          //   width: 150,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          // ,filterable: true
        },
        {
          Header: "Customer",
          accessor: "customer_name",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Reason",
          accessor: "remarks",
          filterable: true,
          width: 250,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  handleSearch = () => {
    let url = "/api/collect/v1/monitoring/get-history-ho";
    let param = {
      org_id: this.state.user.org_id,
      origin: this.state.user.origin,
      submit_from:
        this.state.submittedDateFrom != ""
          ? moment(new Date(this.state.submittedDateFrom)).format("YYYY-MM-DD")
          : "",
      submit_to:
        this.state.submittedDateTo != ""
          ? moment(new Date(this.state.submittedDateTo)).format("YYYY-MM-DD")
          : "",
      trx_number: this.state.sInvoiceNo,
      export: this.state.export,
    };

    this.setState({ loading: true });
    requester.postCollect(url, param, {
      success: function (response) {
        let { data } = response.data;

          if (this.state.export) {
            let url = data.filepath.fullurl;
            this.state.fileurl = url;
            window.open(url, "_blank");
          }

        this.setState({
          loading: false,
          dataTable: data.header,
          export: false,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
    // this.getPrincipal();
    // this.getBranch();
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ submittedDateFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ submittedDateTo: date });
  };

  handleChangeAwb = (e) => {
    this.setState({ sAwbNo: e.target.value });
  };

  handleInvoiceNo = (e) => {
    this.state.sInvoiceNo = e.target.value;
  };

  handleExport = () => {
    this.setState({ export: true });
    let app = this;
    window.setTimeout(() => {
      app.handleSearch();
    }, 200);
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label
                                    htmlFor="inputEmail3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Activity Date From
                                  </label>
                                  <div className="col-sm-8">
                                    <DatePicker
                                      selected={this.state.submittedDateFrom}
                                      dateFormat="d-MMM-yyyy"
                                      className="form-control"
                                      popperPlacement="top-end"
                                      onChange={this.handleSubmittedDateFrom}
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label
                                    htmlFor="inputEmail3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Invoice No.
                                  </label>
                                  <div className="col-sm-8">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      className="form-control"
                                      id="inputEmail3"
                                      name="ref_number"
                                      // placeholder="AWB Number"
                                      onChange={this.handleInvoiceNo.bind(this)}
                                      // defaultValue={this.state.sAwbNumber}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label
                                    htmlFor="inputEmail3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Activity Date To
                                  </label>
                                  <div className="col-sm-8">
                                    <DatePicker
                                      selected={this.state.submittedDateTo}
                                      dateFormat="d-MMM-yyyy"
                                      className="form-control"
                                      popperPlacement="top-end"
                                      onChange={this.handleSubmittedDateTo}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* <div className="col-md-2 mt-1">
                                Activity Date From:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateFrom}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control myDatePicker"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateFrom}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Activity Date To:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateTo}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateTo}
                                />
                              </div>
                              <div className="col-md-2 mt-1">Invoice No: </div>
                              <div className="col-lg-3">
                                <input
                                  disabled
                                  type="text"
                                  autoComplete="off"
                                  className="form-control"
                                  id="inputEmail3"
                                  name="ref_number"
                                  // placeholder="AWB Number"
                                  // defaultValue={this.state.header.doc_no}
                                />
                              </div> */}
                            </div>
                            {/* <div className="clearfix">&nbsp;</div> */}
                            {/* <div className="row"> */}
                            {/* <div className="col-md-2 mt-1">Awb No. </div>
                              <div className="col-lg-3">
                                <input
                                  type="text"
                                  autoComplete="off"
                                  className="form-control"
                                  id="scanfield"
                                  name="ref_number"
                                  placeholder=""
                                  onChange={this.handleChangeAwb.bind(this)}
                                  // onKeyDown={this.handleKeyDown.bind(this)}
                                  // value={this.state.ref_number}
                                />
                              </div> */}
                            {/* </div> */}
                            <div className="clearfix">&nbsp;</div>
                            <div className="row mt-3">
                              <div className="col-md-3">
                                <button
                                  className="btn btn-primary btn-block"
                                  onClick={this.handleSearch.bind(this)}
                                >
                                  <i class="fas fa-search"></i> Search
                                </button>
                              </div>
                              <div className="col-md-3">
                                <button
                                  className="btn btn-success btn-block"
                                  onClick={this.handleExport.bind(this)}
                                >
                                  <i class="fas fa-file-excel" /> Export To
                                  Excel
                                </button>
                              </div>
                              <div className="col-md-3">
                                <span>
                                  {this.state.fileurl == "" ? (
                                    ""
                                  ) : (
                                    <a href={this.state.fileurl}>
                                      Click here to re-download
                                    </a>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default History;
